import React, { useState, useEffect } from "react";
import "./Calendario.css";
import CargandoSpinner from "../../0. Utilidades/loadingSpinner"; // Import the spinner component

const Calendario = () => {
  const [days, setDays] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_API}api/calendario/`;
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        setDays(data.days);
        setEvents(data.events);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching calendar data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div id="calendario">
      <h3>Calendario Semanal</h3>
      {loading ? (
        <CargandoSpinner /> // Show spinner while loading
      ) : (
        <div className="calendario">
          {days.map((day, index) => (
            <div key={index} className="day-container">
              {/* Header for the day */}
              <div className="header-day">{day}</div>

              {/* Events for the day */}
              <div className="day-events">
                {events
                  .filter((event) => event.days.includes(day)) // Filter events by day label
                  .map((event, i) => (
                    <a
                      key={i}
                      href={`/${event.tipo.toLowerCase()}/${event.id}`} // Dynamic URL for curso or actividad
                      className={`event ${event.tipo.toLowerCase()}`}
                    >
                      <span>
                        {event.nombre} <strong>({event.comuna})</strong>
                      </span>
                    </a>
                  ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Calendario;
